import type { ComponentProps, ReactNode } from 'react'

import type { CollectionsApi } from '@fourthwall/services/dist/CollectionsApiClient'

import type { StatusTag } from '../../common'

export type StatusTagDropdownProps = {
  initialIsOpen?: boolean
  headerContent?: ReactNode
  status: 'PUBLIC' | 'HIDDEN' | 'ARCHIVED' | 'SCHEDULE'
  timeFrame?: CollectionsApi.GetCollection.Response['timeFrame']
  isSoldOut: boolean
  disabled?: boolean
  size?: ComponentProps<typeof StatusTag>['size']
  onSubmit: ((values: FormValues) => void) | ((values: FormValues) => Promise<void>)
}

export enum FormFields {
  status = 'status',
  startDate = 'startDate',
  setEndDate = 'setEndDate',
  endDate = 'endDate',
}

export type FormValues = {
  [FormFields.status]: StatusTagDropdownProps['status']
  [FormFields.startDate]?: Date
  [FormFields.setEndDate]: boolean
  [FormFields.endDate]?: Date
}
